import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyKybBaicGst } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import { FiCheckCircle } from 'react-icons/fi';
import Loader from "../../../Loader";
import { useService } from "../../../context/ServiceContext";

import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { kybBasicGstData } from "../data2";
import { FaCopy, FaUser } from "react-icons/fa";


const VerifyKybBasic = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [gstData, setGstData] = useState(null);
  const [responseData, setResponseData] = useState(null);
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [gstNumber, setGstNumber] = useState("");
  const { serviceName } = useService();


  // Fetch profile data on mount
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  // Form validation
  const validateForm = (gstNumber) => {
    const errors = {};

    if (!gstNumber.trim()) {
      errors.gstNumber = "GST is required.";
    } else if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/.test(gstNumber)) {
      errors.gstNumber = "Enter a valid 15-character GST number (e.g., 22ABCDE1234F1Z5).";
    }

    return errors;
  };

  const handleSubmit = async () => {
    const validationErrors = validateForm(gstNumber);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      setIsLoading(true);
      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        "gstin": gstNumber,
      };
      const response = await verifyKybBaicGst(payload);
      setIsLoading(false);
      if (response.status.code === 200) {
        setGstData(response.data);
        setResponseData(response);
        setGstNumber('')
        showSuccessToast(response.message || response.status.message || "Gst Verify Successfully")
      } else {
        setGstData(null);
        setResponseData(null);
        showErrorToast(response.message || response.status.message || response.errors.message || "An unexcepted errors occurs.")
      }



    } catch (error) {
      showErrorToast("Failed to verify GST details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  function handleCopyText(data) {
    window.navigator.clipboard.writeText(JSON.stringify(data));
    showSuccessToast('Copied successfully')
  }

  const renderCompanyCard = () => {
    if (!gstData) {
      return (
        <div className="text-center p-4 bg-red-100 border border-red-300 text-red-700 rounded">
          No gstData data available.
        </div>
      );
    }

    // const renderObject = (obj) => {
    //   return Object.entries(obj).map(([key, value]) => (
    //     <div key={key} className="mb-2">
    //       <span className="font-bold capitalize">{key.replace(/_/g, ' ')}:</span>{" "}
    //       {typeof value === 'object' && value !== null
    //         ? Array.isArray(value)
    //           ? ""
    //           : ""
    //         : value || "N/A"}
    //     </div>
    //   ));
    // };

    const renderObject = (obj) => {
  if (!obj || typeof obj !== "object") {
    return <div className="text-gray-400">No data available</div>;
  }

  return Object.entries(obj).map(([key, value]) => (
    <div key={key} className="mb-2">
      <span className="font-bold capitalize">
        {key.replace(/_/g, " ")}:
      </span>{" "}
      {typeof value === "object" && value !== null
        ? ""
        : value || "N/A"}
    </div>
  ));
};


    // const renderArray = (arr) => {
    //   return arr.map((item, index) => (
    //     <div key={index} className="pl-4 mb-2 border-l-2 border-blue-200">
    //       {typeof item === 'object' ? renderObject(item) : <div className="flex">{item}</div>}
    //     </div>
    //   ));
    // };

    const renderArray = (arr) => {
  if (!Array.isArray(arr)) return null;

  return arr.map((item, index) => (
    <div key={index} className="pl-4 mb-2 border-l-2 border-blue-200">
      {typeof item === "object"
        ? renderObject(item)
        : <div>{item}</div>}
    </div>
  ));
};

    return (
      <div className="relative bg-white/70 backdrop-blur-lg border border-blue-100 p-6 rounded-2xl shadow-xl max-w-4xl mx-auto">
        <h2 className="text-xl font-bold text-blue-700 mb-4 flex items-center gap-2">
          <FiCheckCircle className="text-blue-500 text-2xl" />
          GST Main Details
        </h2>

        <div className="mb-4 flex items-center gap-2">
          <FaUser className="text-blue-600 text-xl" />
          <h2 className="text-2xl font-bold text-blue-900">
            <p><span className="font-semibold">Business Name:</span> {gstData?.taxpayerDetails?.lgnm || "N/A"}</p>
          </h2>
        </div>

        <div className="text-gray-700 text-sm space-y-4">
          {/* Direct DL fields */}
          <div>
            <h3 className="font-semibold text-blue-700 mb-2">Basic Information</h3>
            {renderObject(
              gstData?.taxpayerDetails

            )}
          </div>


          <div>
            <h3 className="font-semibold text-blue-700 mb-2">Taxpayer Return Details</h3>
            <div className="grid grid-cols-3 gap-2">
              {renderArray(gstData?.taxpayerReturnDetails?.filingStatus || [])}
            </div>
          </div>
        
          <div>
            <h3 className="font-semibold text-blue-700 mb-2">Goods_service</h3>
            <div className="">
              {renderArray(gstData?.goods_service?.bzsdtls || [])}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">

        <div className="col-span-2 md:col-span-6 flex justify-end">
          <Link
            to="/TestMaster"
            className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
          >
            <span>Go Back</span>
            <IoArrowBackCircleOutline size={24} />
          </Link>
        </div>


        <InputWithLabel
          type="text"
          label="GST No"
          placeholder="Enter GST No"
          maxLength="18"
          className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="gstin"
          id="gstin"
          required={true}
          value={gstNumber}
          onChange={(e) => setGstNumber(e.target.value)}
          error={errors.gstNumber}
        />

        <div>
          <Button
            type="button"
            className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
            id="verifyGST"
            name="verifyGST"
            text="Verify"
            onClick={handleSubmit}
          />
        </div>
      </div>

      {

        gstData !== null &&
        (
          <div className="grid grid-cols-2 sm:grid-cols-2 gap-2 px-4">
            {/* Main Details Card */}
            <div className="">


              <div className="space-y-2 text-sm text-gray-700">

                <div className="overflow-auto max-h-[600px]">{renderCompanyCard()}</div>
              </div>
            </div>

            <div className="">
              <h3 className="bg-green-200 text-xl font-bold my-2 rounded p-2">Api Response </h3>
              <pre className="bg-black relative text-green-500 p-4 rounded text-sm overflow-auto max-h-[600px]">
                <FaCopy className="absolute top-2 cursor-pointer right-2  bg-white p-1 rounded-md font-bold text-2xl" onClick={() => handleCopyText(responseData)} />
                {JSON.stringify(responseData, null, 2)}
              </pre>
            </div>
          </div>
        )}


    </>
  );
};

export default VerifyKybBasic;
